import { Label } from "./ui/label";
import { Input } from "./ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

export const Field = ({ label, className = "", children }) => (
  <div className={`space-y-1.5 ${className}`}>
    <Label className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">{label}</Label>
    {children}
  </div>
);

export const TextField = ({ label, value, onChange, testId, className, ...rest }) => (
  <Field label={label} className={className}>
    <Input value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={testId} {...rest} />
  </Field>
);

export const SelectField = ({ label, value, onChange, options, testId, placeholder = "Seleziona", className }) => (
  <Field label={label} className={className}>
    <Select value={value || undefined} onValueChange={onChange}>
      <SelectTrigger data-testid={testId}><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent>
        {options.map((o) => (
          <SelectItem key={o.value} value={o.value} data-testid={`${testId}-option-${o.value}`}>{o.label}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  </Field>
);
